var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 115,
    viewBox: "0 0 164 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.89 17.93C158.952 14.4642 157.122 11.3046 154.583 8.76579C152.045 6.22702 148.885 4.3977 145.419 3.46C132.73 0 81.6659 0 81.6659 0C81.6659 0 30.5999 0.105 17.9129 3.565C14.4472 4.50285 11.2876 6.33224 8.74889 8.871C6.21013 11.4098 4.38074 14.5693 3.44289 18.035C-0.39511 40.58 -1.88411 74.931 3.54789 96.573C4.48574 100.039 6.31513 103.198 8.85389 105.737C11.3926 108.276 14.5522 110.105 18.0179 111.043C30.7059 114.503 81.7709 114.503 81.7709 114.503C81.7709 114.503 132.836 114.503 145.524 111.043C148.99 110.105 152.149 108.276 154.688 105.737C157.227 103.198 159.056 100.039 159.994 96.573C164.041 73.997 165.289 39.667 159.889 17.931",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4141 81.7878L107.776 57.2518L65.4141 32.7148V81.7878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3ee8355aa0e7f8be19dd282cf5026ab0.svg";
export { ForwardRef as ReactComponent };